<template>
    <div>
        <Alert type="light-warning">
            <template v-slot:icon>
                <i class="fas fa-exclamation-triangle"/>
            </template>

            <div class="d-flex flex-column gap-4">
                <div>
                    <a class="btn btn-outline-warning" target="_new" :href="$page.props.frontend_url + '/agb'">
                        {{ __('sale.read_youbuyda_conditions') }}
                    </a>
                </div>

                <div>
                    <Checkbox type="warning" v-model="tosAccepted">
                        <b>{{ __('general.i_accepted_the_tos') }}.</b>
                    </Checkbox>
                </div>

                <div>
                    <button class="btn btn-sm btn-warning" :disabled="!tosAccepted" @click="acceptTos">
                        <i class="fas fa-check"/>
                        {{ __('actions.accept_thing', {thing: __('general.tos')}) }}
                    </button>
                </div>
            </div>
        </Alert>
    </div>
</template>

<script>
import Alert from "@components/Alert.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    components: {Checkbox, Alert},

    props: {
        store: Object
    },

    data() {
        return {
            tosAccepted: false
        }
    },

    methods: {
        acceptTos() {
            this.$inertia.post(this.$route('sales.tos.youbuyda.accept'), {
                'store_uuid': this.store.id,
            })
        }
    }
}
</script>
